import type {
  IBackupRepository,
  IBankRequestCacheRepository,
  IMetadataKeyRepository,
  IReportRepository,
} from '@app/domain/ports';

import { BackupRepository, BankRequestCacheRepository, MetadataKeyRepository, ReportRepository } from '../repositories';
import { IndexedDbFactory } from './indexeddb-provider.factory';

/**
 * Factory for creating IndexedDB-based repositories.
 * Handles all repositories that depend on IndexedDB storage.
 */
export class IndexedDbRepositoryFactory {
  constructor(
    private readonly indexedDbFactory: IndexedDbFactory,
    private readonly options: { bankRequestCacheTtlMs: number },
  ) {}

  createBackupRepository(): IBackupRepository {
    return new BackupRepository(this.indexedDbFactory);
  }

  createBankRequestCacheRepository(): IBankRequestCacheRepository {
    return new BankRequestCacheRepository(this.indexedDbFactory, this.options.bankRequestCacheTtlMs);
  }

  createMetadataKeyRepository(): IMetadataKeyRepository {
    return new MetadataKeyRepository(this.indexedDbFactory);
  }

  createReportRepository(): IReportRepository {
    return new ReportRepository(this.indexedDbFactory);
  }
}
